module.exports = __webpack_public_path__ + "img/littleton-logo.e471707b.jpg";